
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class GstReportSummaryGrid extends Serenity.EntityGrid<GstReportSummaryRow, any> {
        protected getColumnsKey() { return GstReportSummaryColumns.columnsKey; }
        protected getDialogType() { return GstReportSummaryDialog; }
        protected getIdProperty() { return GstReportSummaryRow.idProperty; }
        protected getInsertPermission() { return GstReportSummaryRow.insertPermission; }
        protected getLocalTextPrefix() { return GstReportSummaryRow.localTextPrefix; }
        protected getService() { return GstReportSummaryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 1);

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: GstReportSummaryService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;
        }
    }
}